export default "__VITE_ASSET__cU3y0uI$__"